import { render, staticRenderFns } from "./pbi-new-dnc-backtest-analysis.page.vue?vue&type=template&id=3e96fa6c"
import script from "./pbi-new-dnc-backtest-analysis.page.vue?vue&type=script&lang=ts"
export * from "./pbi-new-dnc-backtest-analysis.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports